module.exports = __webpack_public_path__ + "1308ac809bdc41db305df095260a316c.pdf";